import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { DialogModal } from ".";
import { showDialog, hideDialog } from "../../appRedux/actions/common";
import GlobalSettingsForm from "./GlobalSettingsForm";
import { Button } from "antd";

function GlobalSettingsAction() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    dispatch(showDialog({ title: "Global Header Strip Settings", size: "lg" }));
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(hideDialog());
  };

  return (
    <Fragment>
      <Button
        type="default"
        onClick={handleOpen}
        className="me-2"
        style={{ fontWeight: 500 }}
      >
        <i className="fa fa-cog me-1" /> Global Settings
      </Button>
      {open && (
        <DialogModal
          bodyView={<GlobalSettingsForm onClose={handleClose} />}
        />
      )}
    </Fragment>
  );
}

export default GlobalSettingsAction;
